import React, { useEffect, useRef } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

Chart.register(ArcElement, Tooltip, Legend);

const Analytics = () => {
  const chartRef = useRef();

  const clientData = {
    '1 Month': 10,
    '3 Month': 5,
    '6 Month': 8,
    '1 Year': 3,
  };

  const data = {
    labels: Object.keys(clientData),
    datasets: [
      {
        data: Object.values(clientData),
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
        ],
        borderColor: 'rgba(255, 255, 255, 1)',
        borderWidth: 2,
      },
    ],
  };

  useEffect(() => {
    const chartInstance = chartRef.current;
    return () => {
      if (chartInstance) {
        chartInstance.destroy(); // Clean up the chart instance
      }
    };
  }, []);

  return (
    <div className="container mx-auto p-8 min-h-screen">
      <h1 className="text-3xl font-bold mb-12 text-white">Analytics</h1>
      <div className="flex justify-center items-center text-white">
        <Pie
          ref={chartRef}
          data={data}
          options={{
            responsive: true,
            plugins: {
              legend: {
                labels: {
                  color: 'white', // Set legend text color to white
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default Analytics;
